import {asyncLoad, asyncPost, asyncDelete, asyncPatch} from './.';

import * as helpers from 'helpers';

export const loadEstimate = (estimateId, fields = null) => dispatch =>
  asyncLoad({
    dispatch,
    title: 'estimate',
    url: `/estimates/${estimateId}${fields ? `?fields=${fields}` : ''}`,
  });

export const deleteEstimate = estimateId => dispatch =>
  asyncDelete({
    dispatch,
    successMessage: 'The Estimate has been deleted successfully.',
    title: 'estimate',
    url: `/estimates/${estimateId}`,
  });

export const copyEstimate = (estimateId, fields) => async dispatch => {
  const formObject = helpers.formValidation.setupFormBody(fields, false);

  if (formObject.hasError) {
    helpers.handleError(formObject.errorMessage, null, dispatch);
    return null;
  }

  try {
    const result = await asyncPost({
      body: formObject.body,
      dispatch,
      title: 'estimate',
      url: `/estimates/${estimateId}/estimates`,
    });

    return result;
  } catch (err) {
    return null;
  }
};

export const copyToTicket = (estimateId, inventoryLocationId = null) => async (
  dispatch,
  getState,
) => {
  const ticketKeyword = getState().portal.dictionary.Ticket.value;

  try {
    const result = await asyncPost({
      body: {inventoryLocationId},
      dispatch,
      title: `update ${ticketKeyword}`,
      url: `/estimates/${estimateId}/ticket`,
    });

    return result;
  } catch (e) {
    return null;
  }
};

export const copyToInvoice = (
  estimateId,
  approveEstimate = false,
  inventoryLocationId = null,
) => async dispatch => {
  try {
    const result = await asyncPost({
      body: {approveEstimate, inventoryLocationId},
      dispatch,
      title: 'copy invoice',
      url: `/estimates/${estimateId}/invoice`,
    });

    return result;
  } catch (e) {
    return null;
  }
};

export const saveEstimate = (
  estimate,
  updatedItems = null,
  update = false,
) => async dispatch => {
  const formObject = helpers.formValidation.setupFormBody(estimate, update);
  let params = {};

  if (formObject.hasError) {
    helpers.handleError(formObject.errorMessage, null, dispatch);
    return null;
  }

  if (update) {
    try {
      const result = await asyncPatch({
        body: formObject.body,
        dispatch,
        successMessage: 'The estimate has been updated successfully.',
        title: 'estimate',
        url: `/estimates/${estimate.estimateId.value}`,
      });

      return result;
    } catch (err) {
      return null;
    }
  }

  if (formObject.body.estimateId) {
    params = {method: 'PUT'};
  }

  if (updatedItems) {
    formObject.body.items = updatedItems;
  }

  try {
    const result = await asyncPost({
      body: formObject.body,
      dispatch,
      params,
      successMessage: `The estimate has been ${
        formObject.body.estimateId ? 'updated' : 'added'
      } successfully.`,
      title: 'estimate',
      url: `/estimates${
        formObject.body.estimateId ? `/${formObject.body.estimateId}` : ''
      }`,
    });

    return result;
  } catch (err) {
    return null;
  }
};

// TODO remove when API handles this
const mapEstimateSortColumn = col => {
  switch (col) {
    case 'Amount':
      return 'TotalAmount';
    default:
      return col;
  }
};

export const loadEstimates = ({
  sortInfo = {},
  pageInfo = {},
  customViewId,
  searchString,
  statFilter,
}) => dispatch => {
  const sortColumn = mapEstimateSortColumn(sortInfo.sortColumn);
  const params = {
    pageSize: pageInfo.pageSize,
    rowIndex: helpers.rowIndexFromPage(pageInfo),
    sort: helpers.sortParam({
      sortColumn: sortColumn === 'StatusId' ? 'ticketStatus' : sortColumn,
      sortOrder: sortInfo.sortOrder,
    }),
  };
  if (searchString) {
    params.search = encodeURIComponent(searchString);
  } else {
    if (customViewId) {
      params.customFilterId = customViewId;
    }
  }
  if (statFilter) {
    params.customFilter = statFilter;
  }

  return asyncLoad({
    dispatch,
    title: 'Estimates',
    url: `/estimates?includeCardTotals=true&${helpers.objectToParams(params)}`,
  });
};

export const updateQbStatus = (items, status) => dispatch =>
  asyncPost({
    body: {
      updates: items.map(x => ({
        estimateId: x.estimateId,
        status,
      })),
    },
    dispatch,
    params: {method: 'PUT'},
    url: '/estimates/quickbooks/status',
    successMessage: 'QuickBooks status updated',
  });

export const resetQbFlags = items => dispatch =>
  asyncPost({
    body: {
      updates: items.map(x => ({
        estimateId: x.estimateId,
        resetFlags: true,
      })),
    },
    dispatch,
    params: {method: 'PUT'},
    url: '/estimates/quickbooks/status',
    successMessage: 'QuickBooks flags reset',
  });

export const loadSignature = estimateId => dispatch =>
  asyncLoad({
    dispatch,
    title: 'signature',
    url: `/estimates/${estimateId}/signature`,
  });

export const saveSignature = (signature, estimateId) => dispatch =>
  asyncPost({
    body: {signature},
    dispatch,
    url: `/estimates/${estimateId}/signature`,
    successMessage: 'The signature has been saved.',
  });

export const clearSignature = estimateId => dispatch =>
  asyncDelete({
    dispatch,
    url: `/estimates/${estimateId}/signature`,
    successMessage: 'The signature has been cleared.',
  });

export const loadAttachments = ({
  estimateId,
  sortInfo,
  pageInfo,
}) => dispatch => {
  const params = {
    pageSize: pageInfo.pageSize,
    rowIndex: helpers.rowIndexFromPage(pageInfo),
    sort: helpers.sortParam(sortInfo),
  };
  return asyncLoad({
    url: `/estimates/${estimateId}/attachments?${helpers.objectToParams(
      params,
    )}`,
    title: 'Files',
    dispatch,
  });
};



// WEBPACK FOOTER //
// ./src/actions/estimateActions.js